export const DEFAULT_DATE_RANGE = {
  minDate: '1970-01-01',
  maxDate: '2030-12-31',
};
